import { Paper, Stack, SxProps } from "@mui/material";

type MapPanelProps = {
    children: React.ReactNode;
    sx?: SxProps;
    flat?: boolean;
} & (
    | {
          collapsable: true;
          collapsed: boolean;
      }
    | {
          collapsable?: false;
          collapsed?: never;
      }
);

export function MapPanel({ children, sx, collapsable = false, collapsed, flat = false }: MapPanelProps) {
    return (
        <Paper
            component={Stack}
            sx={[
                theme => ({
                    overflow: "auto",
                    ...(collapsable && {
                        flexShrink: collapsed ? 0 : 1,
                        transition: theme.transitions.create(["flex-shrink"], {
                            duration: theme.transitions.duration.short,
                        }),
                    }),
                }),
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...(flat && { variant: "outlined" })}
        >
            {children}
        </Paper>
    );
}
